import * as React from "react";
import { Box, Grow, Paper } from "@mui/material";
import { MINI_DRAWER_WIDTH } from "./constants";

interface SidebarNestedMenuProps {
  open: boolean;
  children: React.ReactNode;
}

const SidebarNestedMenu = ({ open, children }: SidebarNestedMenuProps) => (
  <Grow in={open}>
    <Box
      data-testid="sidebar-nested-menu"
      sx={{ position: "fixed", left: MINI_DRAWER_WIDTH - 2, pl: "6px" }}
    >
      <Paper
        elevation={8}
        sx={{
          pt: 0.2,
          pb: 0.2,
          transform: "translateY(-50px)",
        }}
      >
        {children}
      </Paper>
    </Box>
  </Grow>
);

export default SidebarNestedMenu;
